

 const Url='https://bookstore-mern-app-eozw.onrender.com';
// const Url = "http://localhost:4010";

export default Url;
